import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import BodyText from 'LuxKit/Typography/BodyText'
import ContactContext from 'contexts/contactContext'
import { LUXURY_PLUS } from 'luxPlus/constants/base'
import { useContext } from 'react'
import { useIntl } from 'react-intl'

interface Props {
  onBack?: () => void
}

function LuxPlusManageAccountModalMembershipCancellation({ onBack }: Props) {
  const intl = useIntl()
  const currentContact = useContext(ContactContext)
  const contactNumber = currentContact.defaultContact

  return <>
    <ModalHeader
      title={intl.formatMessage({
        id: 'F2xudg4He_aSQIpFkB-2',
        defaultMessage: 'Cancel membership',
        description: 'Title for the cancel membership modal in the cancellation or refund flow',
      })}
      onBackButtonClick={onBack}
    />
    <ModalBody>
      <ModalContent>
        <BodyText variant="medium">
          {intl.formatMessage(
            {
              id: 'uUxbC3RCj-6gsCHfQouP',
              defaultMessage: 'Thank you for being a part of {programName} and we’re sorry to see you go. To proceed with the cancellation of your membership, we kindly ask that your call our Customer Service team who will assist you further over the phone. Our customer service team are available anytime, 24 hours, 7 days a week.',
              description: 'Body text explaining the membership cancellation process and directing the user to call customer service',
            },
            { programName: LUXURY_PLUS.PROGRAM_NAME },
          )}
        </BodyText>
      </ModalContent>
    </ModalBody>
    <ModalFooter
      primaryActionProps={{
        children: contactNumber.humanReadable,
        startIcon: <LinePhoneIcon />,
        href: `tel:${contactNumber.number}`,
      }}
    />
  </>
}

export default LuxPlusManageAccountModalMembershipCancellation
